import env from 'enviro';

// This type will be imported from LowLevelAuthFlowView in a later branch

export const oAuthRedirectOrigin = `https://oauth-redirect.hubspot${env.isQa() ? 'qa' : ''}.com`;
export function isOAuth(type) {
  return type === 'OAuth' || type === 'OAuthWithPolling';
}
export function isOAuthWithoutPolling(type) {
  return type === 'OAuth';
}
export function isOAuthWithPolling(type) {
  return type === 'OAuthWithPolling';
}